/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import { mergeRuntimeSecretsIntoEnvironment } from './environments/runtime-secrets';
import { exposeKeycloakRefreshMetricsToWindow } from './app/shared/keycloak-refresh-metrics';

mergeRuntimeSecretsIntoEnvironment(environment);

exposeKeycloakRefreshMetricsToWindow(
  (environment as { keycloak?: { exposeRefreshMetrics?: boolean } }).keycloak?.exposeRefreshMetrics === true
);

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
